export default __webpack_public_path__ + "static/flexible-connectivity-b3c2813a36b393c6f869f1b77a56e5a9.png";